import { render, staticRenderFns } from "./HospitalSwitcher.vue?vue&type=template&id=bfc96022&scoped=true&"
import script from "./HospitalSwitcher.vue?vue&type=script&lang=js&"
export * from "./HospitalSwitcher.vue?vue&type=script&lang=js&"
import style0 from "./HospitalSwitcher.vue?vue&type=style&index=0&id=bfc96022&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfc96022",
  null
  
)

export default component.exports